import { _initialState } from './_initialState';

export const productDataStore = (set, get) => ({
  ..._initialState,
  updateProductData: ({ productData }) => set({
    productData,
  }, false, { type: 'updateProductData' }),
  appendProductData: (appendData) => set({
    productData: { ...get().productData, ...appendData },
  }, false, { type: 'appendProductData' }),
  updateFetchedSkus: (skus) => set({
    fetchedSkus: skus
  }, false, { type: 'updateFetchedSkus' }),
  appendFetchedSkus: (additionalSkus) => set({
    fetchedSkus: [...get().fetchedSkus, ...additionalSkus]
  }, false, { type: 'appendFetchedSkus' })
});
